import axios from "axios";
import { toastMessage } from "components/ToastMessage";

/**
 * Shared error handling for MarketAreas thunks: ignore aborted requests and,
 * when a message is provided, surface an error toast. Pass no message to
 * silently swallow non-cancel errors.
 */
export const handleThunkError = (error: unknown, message?: string) => {
  if (axios.isCancel(error)) return;
  if (message) {
    toastMessage({ message, type: "error", position: "top-right" });
  }
};
